// We consider a trailing chars any characters that can be used to end
// or separate a sentence like: ".", ";", ",", ":".
export const TRAILING_CHARS_REGEX = /^([^\s].*?)(?=[\.\;\,\:\s]*$)/gm;

export const URL_REGEX = /(https?:\/\/\S+\.(?:[^\[\]\(\)\s]+(?:\[[^\]]*\])*(?:\([^\)]*\))*)*)/g;

export const IPV4_REGEX = /(https?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))/g;

export const IPV6_REGEX = /https?:\/\/\[((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))\]/g;

export const CONTAINS_POST_VARIABLES_REGEX = /\{\{/g;

export const CONTAINS_INVALID_CHARACTERS = /\u0000/g;

export function findUrls(string) {
  string = stringWithoutTrailingChars(string);

  return (string ? (string.match(URL_REGEX) || []) : []).filter(url => {
    return !(url.match(IPV4_REGEX) || url.match(IPV6_REGEX) || url.match(CONTAINS_POST_VARIABLES_REGEX) || url.match(CONTAINS_INVALID_CHARACTERS));
  });
}

export function findUrlsContaningPostVariables(string) {
  string = stringWithoutTrailingChars(string);

  return (string ? (string.match(URL_REGEX) || []) : []).filter(url => {
    return !(url.match(IPV4_REGEX) || url.match(IPV6_REGEX) || url.match(CONTAINS_INVALID_CHARACTERS)) && url.match(CONTAINS_POST_VARIABLES_REGEX);
  });
}

export function addProtocolToUrl(url) {
  if (!/^https?:\/\//i.test(url))
    return `https://${url}`;

  return url;
}

export function getUrlHostname(url) {
  if (!url) return;

  try {
    return new URL(addProtocolToUrl(url)).hostname.replace("www.", "");
  } catch(e) {
    console.error("Error parsing url", url, e);
    return url;
  }
}

export function stringWithoutTrailingChars(string) {
  return (string?.match(TRAILING_CHARS_REGEX) || [string]).join(' ');
}

const BLOCKED_BRAND_DOMAINS = [
  'facebook.com', 'fb.com', 'instagram.com', 'twitter.com', 'x.com',
  'linkedin.com', 'youtube.com', 'tiktok.com', 'pinterest.com', 'snapchat.com',
  'reddit.com', 'tumblr.com', 'threads.net', 'mastodon.social', 'bsky.app',
  'whatsapp.com', 'telegram.org', 't.me', 'discord.com', 'discord.gg',
  'twitch.tv', 'vimeo.com', 'dailymotion.com', 'flickr.com', 'wechat.com',
  'weibo.com', 'line.me', 'quora.com', 'medium.com', 'substack.com',
  'bluesky.social', 'google.com', 'bing.com', 'yahoo.com', 'duckduckgo.com',
  'amazon.com', 'ebay.com', 'etsy.com', 'apple.com', 'microsoft.com',
  'github.com', 'gitlab.com', 'bitbucket.org', 'wordpress.com', 'blogger.com',
  'wix.com', 'squarespace.com', 'shopify.com', 'linktr.ee', 'bit.ly',
  'gmail.com', 'hotmail.com', 'outlook.com', 'live.com', 'aol.com',
  'icloud.com', 'me.com', 'mac.com', 'mail.com', 'protonmail.com',
  'proton.me', 'zoho.com', 'yandex.com', 'yandex.ru', 'gmx.com',
  'gmx.net', 'fastmail.com', 'tutanota.com', 'tuta.com', 'hushmail.com',
  'mailfence.com', 'hey.com', 'pm.me', 'inbox.com', 'rediffmail.com',
  'qq.com', '163.com', '126.com', 'sina.com', 'naver.com',
  'daum.net', 'libero.it', 'laposte.net', 'orange.fr', 'web.de',
  't-online.de', 'comcast.net', 'verizon.net', 'att.net', 'sbcglobal.net',
  'cox.net', 'earthlink.net', 'btinternet.com', 'sky.com', 'rogers.com',
  'shaw.ca', 'bell.net', 'bigpond.com',
];

function extractRegisteredDomain(hostname) {
  const parts = hostname.split('.');
  if (parts.length < 2) return hostname;
  
  const commonMultiPartTLDs = [
    'co.uk', 'co.jp', 'co.kr', 'co.nz', 'co.za', 'co.in', 'co.id', 'co.th',
    'com.au', 'com.br', 'com.cn', 'com.mx', 'com.ar', 'com.sg', 'com.my',
    'com.ph', 'com.hk', 'com.tw', 'com.vn', 'com.pk', 'com.eg', 'com.tr',
    'com.sa', 'com.ng', 'com.bd', 'com.ua', 'com.pe', 'com.co', 'com.ve',
    'net.au', 'net.br', 'net.cn', 'net.nz', 'net.in', 'net.ph', 'net.my',
    'org.uk', 'org.au', 'org.nz', 'org.za', 'org.in', 'org.br', 'org.cn',
    'ac.uk', 'ac.nz', 'ac.za', 'ac.in', 'ac.jp', 'ac.kr', 'ac.th',
    'gov.uk', 'gov.au', 'gov.br', 'gov.in', 'gov.cn', 'gov.sg',
    'edu.au', 'edu.cn', 'edu.my', 'edu.sg', 'edu.hk', 'edu.tw'
  ];
  
  const lastTwo = parts.slice(-2).join('.');
  const lastThree = parts.length >= 3 ? parts.slice(-3).join('.') : null;
  
  if (lastThree && commonMultiPartTLDs.includes(lastTwo)) {
    return lastThree;
  }
  
  return lastTwo;
}

export function validateBrandWebsite(url) {
  if (!url) return null;
  if (/\s/.test(url)) return 'Please enter a valid URL (e.g. https://example.com)';
  try {
    const u = new URL(url);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return 'Please enter a valid URL (e.g. https://example.com)';
    }
    if (!u.hostname.includes('.')) {
      return 'Please enter a valid URL (e.g. https://example.com)';
    }
    const hostname = u.hostname.replace(/^www\./, '').toLowerCase();
    const registeredDomain = extractRegisteredDomain(hostname);
    if (BLOCKED_BRAND_DOMAINS.includes(registeredDomain)) {
      return 'Please enter your own brand website, not a social media, generic platform, or email provider URL';
    }
  } catch (e) {
    return 'Please enter a valid URL (e.g. https://example.com)';
  }
  return null;
}
